import Vue from 'vue';

import PxSituacaoAprovacao from '@/components/PxSituacaoAprovacao.vue';
import PxSituacaoAprovacaoIcon from '@/components/PxSituacaoAprovacaoIcon.vue';
import PxAutocompleteCadastroAdicionalMultiple
  from '@/components/PxAutocompleteCadastroAdicionalMultiple.vue';
import UserInfo from './user-info/UserInfo.vue';
import PxCarrinho from './carrinho/PxCarrinho.vue';
import PxSituacaoCompraIcon from './PxSituacaoCompraIcon.vue';
import PxStatusNegociacao from './PxStatusNegociacao.vue';
import PxEspecificacaoProdutoComparavel from './PxEspecificacaoProdutoComparavel.vue';
import PxPopoverFornecedor from './PxPopoverFornecedor.vue';
import PxAutocompleteComprador from './PxAutocompleteComprador.vue';
import PxAutocompleteCotacao from './PxAutocompleteCotacao.vue';
import PxAutocompleteCotacaoProduto from './PxAutocompleteCotacaoProduto.vue';
import PxListaSelecaoFornecedores from './lista-selecao-fornecedor/PxListaSelecaoFornecedores.vue';
import PxIndicadorCompra from './PxIndicadorCompra.vue';
import PxAutocompleteUserGrupo from './PxAutocompleteUserGrupo.vue';
import PxRespostaPrazoPreco from './PxRespostaPrazoPreco.vue';
import PxRefresh from './PxRefresh.vue';
import PxFornecedorScore from './PxFornecedorScore.vue';
import PxOpenPaginaFornecedor from './PxOpenPaginaFornecedor.vue';
import PxHistoricoPrecoProdutoMenu from './PxHistoricoPrecoProdutoMenu.vue';
import PxHistoricoPrecoProduto from './PxHistoricoPrecoProduto.vue';
import PxAutocompleteCentroCusto from './PxAutocompleteCentroCusto.vue';
import PxAutocompleteUserCompradorMultiple from './PxAutocompleteUserCompradorMultiple.vue';
import PxAutocompleteCentroCustoMultiple from './PxAutocompleteCentroCustoMultiple.vue';
import PxAutocompleteUserComprador from './PxAutocompleteUserComprador.vue';
import PxAutocompleteProdutoMultiple from './PxAutocompleteProdutoMultiple.vue';
import PxAutocompleteProjetoMultiple from './PxAutocompleteProjetoMultiple.vue';
import PxAutocompleteTiposUsoMultiple from './PxAutocompleteTiposUsoMultiple.vue';
import PxEntregaMenu from './PxEntregaMenu.vue';
import PxSelectDateRange from './PxSelectDateRange.vue';
import CamposIntegracao from './CamposIntegracao.vue';
import PxAutocompleteCadastroAdicional from './PxAutocompleteCadastroAdicional.vue';
import PxAutocompleteProjeto from './PxAutocompleteProjeto.vue';
import PxAutocompleteNotaEntrada from './PxAutocompleteNotaEntrada.vue';
import PxAutocompleteModoDePagamento from './PxAutocompleteModoDePagamento.vue';
import PxAutocompleteGrupo from './PxAutocompleteGrupo.vue';
import PxAutocompleteTiposUso from './PxAutocompleteTiposUso.vue';
import PxAutocompleteTransportadora from './PxAutocompleteTransportadora.vue';
import PxCadastroProdutoCamposAdicionais from './PxCadastroProdutoCamposAdicionais.vue';
import PxCadastroProdutoObservacoes from './PxCadastroProdutoObservacoes.vue';
import PxPrecoTarget from './PxPrecoTarget.vue';
import PxRequisicaoUrgenciaIcon from './PxRequisicaoUrgenciaIcon.vue';
import PxIndicadorCompraProduto from './PxIndicadorCompraProduto.vue';
import PxAutocompleteMensagemPersonalizada from './mensagens-personalizadas/PxAutocompleteMensagemPersonalizada.vue';
import PxMensagensPersonalizadasList from './mensagens-personalizadas/PxMensagensPersonalizadasList.vue';
import PxShowAtivoProduto from './PxShowAtivoProduto.vue';
import PxInputLogo from './PxInputLogo.vue';
import PxTipoNotificacao from './PxTipoNotificacao.vue';
import PxShowSaving from './PxShowSaving.vue';
import PxAutocompleteGrupoMultiple from './PxAutocompleteGrupoMultiple.vue';
import PxShowTipoProduto from './PxShowTipoProduto.vue';
import PxAutocompleteFornecedorMultiple from './PxAutocompleteFornecedorMultiple.vue';
import PxAutocompleteFornecedorGrupoMultiple from './PxAutocompleteFornecedorGrupoMultiple.vue';
import PxSituacaoUserAprovacao from './PxSituacaoUserAprovacao.vue';
import PxListaLinks from './links/PxListaLinks.vue';
import PxAprovacaoRecusarDialog from './PxAprovacaoRecusarDialog.vue';
import PxAprovacaoProdutoAprovadores from './PxAprovacaoProdutoAprovadores.vue';
import PxAprovacaoDetalhesProdutoCompras from './PxAprovacaoDetalhesProdutoCompras.vue';
import PxAprovacaoDetalhesProdutoCotacoes from './PxAprovacaoDetalhesProdutoCotacoes.vue';
import PxShowFornecedoresHomologadosProduto from './homologacao/PxShowFornecedoresHomologadosProduto.vue';
import PxShowIsHomologado from './homologacao/PxShowIsHomologado.vue';
import PxShowQuantidadeProdutosHomologados from './homologacao/PxShowQuantidadeProdutosHomologados.vue';
import PxAutocompletePais from './PxAutocompletePais.vue';
import PxAutocompleteLocaisEntrega from './PxAutocompleteLocaisEntrega.vue';
import PxPrevisaoEntregaRequisicaoProduto from './PxPrevisaoEntregaRequisicaoProduto.vue';
import PxAprovacaoDetalhesProdutoEstoque from './PxAprovacaoDetalhesProdutoEstoque.vue';
import PxCadastroEnderecoInternacional from './endereco/PxCadastroEnderecoInternacional.vue';
import PxCadastroEnderecoNacional from './endereco/PxCadastroEnderecoNacional.vue';
import PxCodInternoCodProxpectCompra from './PxCodInternoCodProxpectCompra.vue';
import PxNotificacaoInfo from './PxNotificacaoInfo.vue';
import DisableUpdateIfBlocked from './disable-if-blocked-update';
import PxResumoProdutoDialog from './PxResumoProdutoDialog.vue';

Vue.component('pxUserInfo', UserInfo);
Vue.component('pxCarrinho', PxCarrinho);
Vue.component('pxSituacaoCompraIcon', PxSituacaoCompraIcon);
Vue.component('pxStatusNegociacao', PxStatusNegociacao);
Vue.component('PxEspecificacaoProdutoComparavel', PxEspecificacaoProdutoComparavel);
Vue.component('PxPopoverFornecedor', PxPopoverFornecedor);
Vue.component('PxAutocompleteComprador', PxAutocompleteComprador);
Vue.component('PxAutocompleteCotacao', PxAutocompleteCotacao);
Vue.component('PxAutocompleteCotacaoProduto', PxAutocompleteCotacaoProduto);
Vue.component('PxListaSelecaoFornecedores', PxListaSelecaoFornecedores);
Vue.component('PxAutocompleteUserGrupo', PxAutocompleteUserGrupo);
Vue.component('PxIndicadorCompra', PxIndicadorCompra);
Vue.component('PxRespostaPrazoPreco', PxRespostaPrazoPreco);
Vue.component('PxRefresh', PxRefresh);
Vue.component('PxFornecedorScore', PxFornecedorScore);
Vue.component('PxOpenPaginaFornecedor', PxOpenPaginaFornecedor);
Vue.component('PxHistoricoPrecoProdutoMenu', PxHistoricoPrecoProdutoMenu);
Vue.component('PxHistoricoPrecoProduto', PxHistoricoPrecoProduto);
Vue.component('PxAutocompleteCentroCusto', PxAutocompleteCentroCusto);
Vue.component('PxAutocompleteUserCompradorMultiple', PxAutocompleteUserCompradorMultiple);
Vue.component('PxSituacaoAprovacao', PxSituacaoAprovacao);
Vue.component('PxAutocompleteCentroCustoMultiple', PxAutocompleteCentroCustoMultiple);
Vue.component('PxAutocompleteUserComprador', PxAutocompleteUserComprador);
Vue.component('PxAutocompleteProdutoMultiple', PxAutocompleteProdutoMultiple);
Vue.component('PxAutocompleteProjetoMultiple', PxAutocompleteProjetoMultiple);
Vue.component('PxAutocompleteTiposUsoMultiple', PxAutocompleteTiposUsoMultiple);
Vue.component('PxEntregaMenu', PxEntregaMenu);
Vue.component('PxSelectDateRange', PxSelectDateRange);
Vue.component('PxCamposIntegracao', CamposIntegracao);
Vue.component('PxAutocompleteCadastroAdicional', PxAutocompleteCadastroAdicional);
Vue.component('PxAutocompleteProjeto', PxAutocompleteProjeto);
Vue.component('PxAutocompleteNotaEntrada', PxAutocompleteNotaEntrada);
Vue.component('PxAutocompleteModoDePagamento', PxAutocompleteModoDePagamento);
Vue.component('PxAutocompleteGrupo', PxAutocompleteGrupo);
Vue.component('PxAutocompleteTiposUso', PxAutocompleteTiposUso);
Vue.component('PxAutocompleteTransportadora', PxAutocompleteTransportadora);
Vue.component('PxCadastroProdutoCamposAdicionais', PxCadastroProdutoCamposAdicionais);
Vue.component('PxCadastroProdutoObservacoes', PxCadastroProdutoObservacoes);
Vue.component('PxPrecoTarget', PxPrecoTarget);
Vue.component('PxRequisicaoUrgenciaIcon', PxRequisicaoUrgenciaIcon);
Vue.component('PxIndicadorCompraProduto', PxIndicadorCompraProduto);
Vue.component('PxAutocompleteMensagemPersonalizada', PxAutocompleteMensagemPersonalizada);
Vue.component('PxMensagensPersonalizadasList', PxMensagensPersonalizadasList);
Vue.component('PxShowAtivoProduto', PxShowAtivoProduto);
Vue.component('PxInputLogo', PxInputLogo);
Vue.component('PxTipoNotificacao', PxTipoNotificacao);
Vue.component('PxShowSaving', PxShowSaving);
Vue.component('PxAutocompleteGrupoMultiple', PxAutocompleteGrupoMultiple);
Vue.component('PxShowTipoProduto', PxShowTipoProduto);
Vue.component('PxAutocompleteFornecedorMultiple', PxAutocompleteFornecedorMultiple);
Vue.component('PxAutocompleteFornecedorGrupoMultiple', PxAutocompleteFornecedorGrupoMultiple);
Vue.component('PxSituacaoAprovacaoIcon', PxSituacaoAprovacaoIcon);
Vue.component('PxSituacaoUserAprovacao', PxSituacaoUserAprovacao);
Vue.component('PxListaLinks', PxListaLinks);
Vue.component('PxAprovacaoRecusarDialog', PxAprovacaoRecusarDialog);
Vue.component('PxAprovacaoProdutoAprovadores', PxAprovacaoProdutoAprovadores);
Vue.component('PxAprovacaoDetalhesProdutoCompras', PxAprovacaoDetalhesProdutoCompras);
Vue.component('PxAprovacaoDetalhesProdutoCotacoes', PxAprovacaoDetalhesProdutoCotacoes);
Vue.component('PxShowFornecedoresHomologadosProduto', PxShowFornecedoresHomologadosProduto);
Vue.component('PxShowIsHomologado', PxShowIsHomologado);
Vue.component('PxShowQuantidadeProdutosHomologados', PxShowQuantidadeProdutosHomologados);
Vue.component('PxAutocompletePais', PxAutocompletePais);
Vue.component('PxAutocompleteLocaisEntrega', PxAutocompleteLocaisEntrega);
Vue.component('PxPrevisaoEntregaRequisicaoProduto', PxPrevisaoEntregaRequisicaoProduto);
Vue.component('PxAutocompleteCadastroAdicionalMultiple', PxAutocompleteCadastroAdicionalMultiple);
Vue.component('PxAprovacaoDetalhesProdutoEstoque', PxAprovacaoDetalhesProdutoEstoque);
Vue.component('PxCadastroEnderecoInternacional', PxCadastroEnderecoInternacional);
Vue.component('PxCadastroEnderecoNacional', PxCadastroEnderecoNacional);
Vue.component('PxCodInternoCodProxpectCompra', PxCodInternoCodProxpectCompra);
Vue.component('PxNotificacaoInfo', PxNotificacaoInfo);
Vue.component('PxResumoProdutoDialog', PxResumoProdutoDialog);

// Directives declaration
Vue.directive('disable-update-if-blocked', DisableUpdateIfBlocked);
